export enum MenuNameEnum {
  MainMenu = 'mainMenu',
  SetupMenu = 'setupMenu',
  FooterMenu = 'footerMenu',
  FooterBottomBarMenu = 'footerBottomBarMenu',
  AdminMenu = 'adminMenu',
}
